import React, { memo, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider'
import { BarChart, ComposedChart, Bar, Line, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { PapiroConsole } from '../../../../utils/papiroConsole';
import { Checkbox, FormControlLabel, FormGroup, IconButton, Menu, MenuItem } from '@mui/material';
import {MoreVert } from '@mui/icons-material';

const MontlyServiceTimeAverage = memo(function MontlyServiceTimeAverage(props) {

  const [data, setData] = useState(props.data)
  const [attendanceTimeAverageHidden, setAttendanceTimeAverageHidden] = useState(true)
  const [longerAttendanceTimeHidden, setLongerAttendanceTimeHidden] = useState(true)
  const [shorterAttendanceTimeHidden, setShorterAttendanceTimeHidden] = useState(true)

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  useEffect(() => {
    if (props.data != data)
      setData(props.data)
  }, [props.data])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  const getIntroOfPage = (dataKey, payload) => {
    if (dataKey === "attendancetimeaverage")
      return payload.attendancetimeaveragedata != null && payload.attendancetimeaveragedata.length > 0 ? payload.attendancetimeaveragedata : payload.attendancetimeaverage
    if (dataKey === "longerattendancetime")
      return payload.longerattendancetimedata != null && payload.longerattendancetimedata.length > 0 ? payload.longerattendancetimedata : payload.longerattendancetime
    if (dataKey === "shorterattendancetime")
      return payload.shorterattendancetimedata != null && payload.shorterattendancetimedata.length > 0 ? payload.shorterattendancetimedata : payload.shorterattendancetime
    return '';
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`${label}`}</p>
          {payload.map((item) => {
            return <p className="intro">{`${item.name} : ${item.payload != null ? getIntroOfPage(item.dataKey, item.payload) : item.value}`}</p>
          })}
        </div>
      );
    }
  
    return null;
  };

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        title={props.intl.formatMessage({ id: "productivity.dashboard.montly.service.time.in.hours" })}
        action={
          <IconButton
            id='settings-button'
            aria-label="settings"
            aria-controls={open ? 'settings-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick} >
            <MoreVert />
          </IconButton>
        } />
        <Menu
        id="settings-menu"
        MenuListProps={{
          'aria-labelledby': 'settings-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose} >
        <MenuItem key="attendancetimeaverage">
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={attendanceTimeAverageHidden} onChange={() => setAttendanceTimeAverageHidden(!attendanceTimeAverageHidden)} />} label={props.intl.formatMessage({ id: "productivity.dashboard.service.time.average.in.hours" })} />
          </FormGroup>
        </MenuItem>
        <MenuItem key="longerattendancetime">
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={longerAttendanceTimeHidden} onChange={() => setLongerAttendanceTimeHidden(!longerAttendanceTimeHidden)} />} label={props.intl.formatMessage({ id: "productivity.dashboard.larger.service.time.in.hours" })} />
          </FormGroup>
        </MenuItem>
        <MenuItem key="shorterattendancetime">
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={shorterAttendanceTimeHidden} onChange={() => setShorterAttendanceTimeHidden(!shorterAttendanceTimeHidden)} />} label={props.intl.formatMessage({ id: "productivity.dashboard.shorter.service.time.in.hours" })} />
          </FormGroup>
        </MenuItem>
      </Menu>
      <Divider />
      <CardContent>
          <ComposedChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }} >
            <XAxis dataKey="monthyear" />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />
            { attendanceTimeAverageHidden && <Bar dataKey="attendancetimeaverage" name={props.intl.formatMessage({ id: "productivity.dashboard.service.time.average.in.hours" })} fill="#8884d8" /> }
            { longerAttendanceTimeHidden && <Line type="monotone" name={props.intl.formatMessage({ id: "productivity.dashboard.larger.service.time.in.hours" })} dataKey="longerattendancetime" fill="#ff7300" /> }
            { shorterAttendanceTimeHidden && <Line type="monotone" name={props.intl.formatMessage({ id: "productivity.dashboard.shorter.service.time.in.hours" })} dataKey="shorterattendancetime" fill="#82ca9d" /> }
          </ComposedChart>
      </CardContent>
    </Card>
  )
})

export default injectIntl(MontlyServiceTimeAverage)